// Imported first, before any schema exists: zod would otherwise probe `new Function` to speed up
// parsing, which the page's Content-Security-Policy (no eval) blocks and reports in the console.
import { config } from 'zod';

config({ jitless: true });
